import AccessibleFakeButton from './AccessibleFakeButton';
import injectInk from '../Inks/injectInk';

export default injectInk(AccessibleFakeButton);



// WEBPACK FOOTER //
// ./src/js/Helpers/AccessibleFakeInkedButton.js